import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FOURTH_PIE_CHART_HELPER = data => {
  const PieChartConfig = {
    chart: {
      ...chartConfig.chart,
      type: "pie",
      spacingBottom: 60,
      spacingLeft: 0,
      spacingRight: 0,
      className: "chart-background",
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.FIFTH._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      align: "center",
      text: ""
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      text: "",
      align: "center",
      verticalAlign: "bottom"
    },
    plotOptions: {
      series: {
        animation: false
      },
      pie: {
        showInLegend: true,
        point: {
          events: {
            legendItemClick: function() {
              this.slice(null);
              return false;
            }
          }
        }
      }
    },
    series: [
      {
        name: "Issues",
        // colorByPoint: true,
        data: [],
        dataLabels: {
          enabled: true,
          format: `<span style="color:{point.color}">{point.y}</span>`
        }
      }
    ],
    legend: {
      padding: 0,
      enabled: true,
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      floating: false,
      alignColumns: false
    },
    tooltip: {
      formatter: function() {
        return `
                <b>${this.key}</b><br />
                <b>Projects: ${this.y}</b>
              `;
      }
    }
  };

  try {
    // set data
    const {
      projectImplementationModeCountDTOList: list = [],
      totalActiveProjects = 0
    } = data;
    PieChartConfig.series[0].data = list.map(
      ({ implementationMode: name, count: y }, index) => {
        return { name, y };
      }
    );
    PieChartConfig.title.text = `UNDER CONSIDERATION : ${totalActiveProjects} OPEN PROJECTS`;
    PieChartConfig.subtitle.text = `Implementation mode within ${totalActiveProjects} projects pending for issue resolution
under PMG mechanism`;
    return PieChartConfig;
  } catch (error) {
    console.error(error);
  }
};
